import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLeaseCompStore } from '../..';
import useInsightsShape from '../../hooks/useInsightsShape';
import useLeaseCompsInsideShape from '../../hooks/useLeaseCompsInsideShape';
import useLeaseCompsWithGlobalFilters from '../../hooks/useLeaseCompsWithGlobalFilters';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import LeaseCompsGrid from '../leaseComps/LeaseCompsGrid';

function InsightsLeaseCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const leaseCompStore = useLeaseCompStore();
    const insightsShape = useInsightsShape();
    const leaseComps = useLeaseCompsWithGlobalFilters(useLeaseCompsInsideShape(leaseCompStore.leaseComps, insightsShape));

    useEffect(() => setEntityCount(leaseComps.length), [leaseComps]);

    if (!visible || !insightsShape)
        return null;

    return (
        <LeaseCompsGrid leaseComps={leaseComps} />
    );
}

export default observer(InsightsLeaseCompsTab);